// extracted by mini-css-extract-plugin
module.exports = {"txt":"component-module--txt--3r3G5","container":"component-module--container--2bXeW"};